import { ActorModel } from "../fhir/fhir.types";
import { ScheduleModel } from "../fhir/ScheduleService";
import { ScheduleSummary } from "./Scheduling.types";

export function mapScheduleSummary(
  schedule: ScheduleModel,
): ScheduleSummary {
  return {
    id: schedule.id,
    title: schedule.actor.display,
    subtitle:
      schedule.serviceLabels.join(" · ") || schedule.actor.subtitle || undefined,
    description: schedule.comment,
    actorType: schedule.actor.type,
    actorReference: schedule.actor.reference,
    active: schedule.active,
    kind: "schedule",
  };
}

export function unlinkedCalendarId(actorReference: string): string {
  return `unlinked:${actorReference}`;
}

export function mapUnlinkedAppointmentsCalendar(
  actor: ActorModel,
): ScheduleSummary {
  return {
    id: unlinkedCalendarId(actor.reference),
    title: "Unlinked appointments",
    subtitle: actor.display,
    description: actor.subtitle,
    actorType: actor.type,
    actorReference: actor.reference,
    active: actor.active,
    kind: "unlinked",
  };
}
